// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.group {
    display: flex;
    line-height: 28px;
    align-items: center;
    position: relative;
    /* max-width: 190px; */
    /* left: 5%; */
    width: 30%;
    z-index: 3;
   }
   
   .inputSearch {
    width: 100%;
    height: 30px;
    line-height: 28px;
    padding: 0 1rem;
    padding-left: 2.5rem;
    border: 2px solid transparent;
    border-radius: 4px;
    outline: none;
    /* background-color: #fbfbfb21; */
    background-color: #fbfbfbcc;
    color: #424242;
    font-size: var(--font-size-small);
    transition: .3s ease;
    color: var(--txt-color);
    font-weight: unset !important;
    box-shadow: 1px 1px 1px 1px rgba(72, 65, 65, 0.56);
   }
   
   .inputSearch::placeholder {
    color:var(--txt-color-low);
   }
   
   .inputSearch:focus, .inputSearch:hover {
    outline: none;
    /* border-color: rgba(76, 139, 234, 0.815); */
    background-color: #fff;
    /* box-shadow: 0 0 0 4px rgba(41, 84, 148, 0.815); */
    color: #424242;
   }
   
   .icon {
    position: absolute;
    right: 1rem;
    fill: var(--txt-color);
    width: 1rem;
    height: 1rem;
    
   }
   
   
   /* **************************** horizontal Movil****************************** */
  @media (min-width: 500px) and (max-width: 900px) {
    .inputSearch{
        height: 15px;
    }
  }
  
  /* ****************************Movil****************************** */
  @media (max-width: 500px) {
    .group{
        width: 40%;
    }
  }
   
   
   `, "",{"version":3,"sources":["webpack://./src/components/generales/styles/Search.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,UAAU;IACV,UAAU;GACX;;GAEA;IACC,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,6BAA6B;IAC7B,kBAAkB;IAClB,aAAa;IACb,iCAAiC;IACjC,2BAA2B;IAC3B,cAAc;IACd,iCAAiC;IACjC,oBAAoB;IACpB,uBAAuB;IACvB,6BAA6B;IAC7B,kDAAkD;GACnD;;GAEA;IACC,0BAA0B;GAC3B;;GAEA;IACC,aAAa;IACb,6CAA6C;IAC7C,sBAAsB;IACtB,oDAAoD;IACpD,cAAc;GACf;;GAEA;IACC,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,YAAY;;GAEb;;;GAGA,gFAAgF;EACjF;IACE;QACI,YAAY;IAChB;EACF;;EAEA,oEAAoE;EACpE;IACE;QACI,UAAU;IACd;EACF","sourcesContent":[".group {\r\n    display: flex;\r\n    line-height: 28px;\r\n    align-items: center;\r\n    position: relative;\r\n    /* max-width: 190px; */\r\n    /* left: 5%; */\r\n    width: 30%;\r\n    z-index: 3;\r\n   }\r\n   \r\n   .inputSearch {\r\n    width: 100%;\r\n    height: 30px;\r\n    line-height: 28px;\r\n    padding: 0 1rem;\r\n    padding-left: 2.5rem;\r\n    border: 2px solid transparent;\r\n    border-radius: 4px;\r\n    outline: none;\r\n    /* background-color: #fbfbfb21; */\r\n    background-color: #fbfbfbcc;\r\n    color: #424242;\r\n    font-size: var(--font-size-small);\r\n    transition: .3s ease;\r\n    color: var(--txt-color);\r\n    font-weight: unset !important;\r\n    box-shadow: 1px 1px 1px 1px rgba(72, 65, 65, 0.56);\r\n   }\r\n   \r\n   .inputSearch::placeholder {\r\n    color:var(--txt-color-low);\r\n   }\r\n   \r\n   .inputSearch:focus, .inputSearch:hover {\r\n    outline: none;\r\n    /* border-color: rgba(76, 139, 234, 0.815); */\r\n    background-color: #fff;\r\n    /* box-shadow: 0 0 0 4px rgba(41, 84, 148, 0.815); */\r\n    color: #424242;\r\n   }\r\n   \r\n   .icon {\r\n    position: absolute;\r\n    right: 1rem;\r\n    fill: var(--txt-color);\r\n    width: 1rem;\r\n    height: 1rem;\r\n    \r\n   }\r\n   \r\n   \r\n   /* **************************** horizontal Movil****************************** */\r\n  @media (min-width: 500px) and (max-width: 900px) {\r\n    .inputSearch{\r\n        height: 15px;\r\n    }\r\n  }\r\n  \r\n  /* ****************************Movil****************************** */\r\n  @media (max-width: 500px) {\r\n    .group{\r\n        width: 40%;\r\n    }\r\n  }\r\n   \r\n   \r\n   "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
